export const ApiUrl = "https://db.ficei.zu.edu.ly/";
